import script from "./HrHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./HrHeader.vue?vue&type=script&setup=true&lang=js"

import "./HrHeader.vue?vue&type=style&index=0&id=0d01d541&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d01d541"]])

export default __exports__
import QHeader from 'quasar/src/components/header/QHeader.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QHeader});
